export default "__VITE_ASSET__1287ae60__"